import { FlexLayout } from '@deity/falcon-ui';
import { Button, Icon } from '@deity-io/portal-ui';
import { CircularProgress } from '@mui/material';
import type { FC } from 'react';

interface SaveCancelWidgetProps {
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}
export const SaveCancelWidget: FC<SaveCancelWidgetProps> = ({ onSave, onCancel, isSaving }) => (
  <FlexLayout>
    <Button disabled={isSaving} variant="text" onClick={onCancel}>
      Cancel
    </Button>
    <Button
      disabled={isSaving}
      sx={{ ml: 2 }}
      startIcon={isSaving ? <CircularProgress color="inherit" size={20} /> : <Icon icon="save" />}
      onClick={onSave}
    >
      Save
    </Button>
  </FlexLayout>
);
